import React from "react";
import { FaStar } from "react-icons/fa6";

// Five stars filled up to the rounded rating.
export function Stars({ value = 0, size = 14 }) {
  const filled = Math.round(value || 0);
  return (
    <span className="inline-flex gap-0.5" aria-label={`${value || 0} out of 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <FaStar key={n} size={size} className={n <= filled ? "text-amber-400" : "text-white/15"} />
      ))}
    </span>
  );
}

// "★★★★★ 4.8 (12)" - or a quiet "No ratings yet" for a member with no reviews.
export function RatingText({ avg, count, size = 14 }) {
  if (!count) return <span className="text-xs text-gray-500">No ratings yet</span>;
  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <Stars value={avg} size={size} />
      <span className="font-semibold text-white">{avg.toFixed(1)}</span>
      <span className="text-gray-400">({count})</span>
    </span>
  );
}

// Clickable stars for leaving a review.
export function StarInput({ value, onChange }) {
  return (
    <span className="inline-flex gap-1" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          onClick={() => onChange(n)}
          className="p-0.5"
        >
          <FaStar size={26} className={n <= value ? "text-amber-400" : "text-white/20 hover:text-amber-400/60"} />
        </button>
      ))}
    </span>
  );
}
